import { ReactComponent as IconClose } from 'assets/icons/IconCloseSm.svg'

const Banner = ({ text, linkText, onClose }) => {
  return (
    <div className="banner">
      <p className="banner__text">{text}</p>
      <a
        className="banner__link"
        href="https://support.venuenext.net/hc/en-us/articles/9773070360211-Managing-Display-Categories"
      >
        {linkText}
      </a>
      <button className="banner__close-icon" onClick={onClose}>
        <IconClose width="14" height="14" />
      </button>
    </div>
  )
}

export default Banner
